import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clear"]

  connect() {
    this._bound = () => this._update()
    this.element.addEventListener("input", this._bound)
    this.element.addEventListener("change", this._bound)
    this._update()
  }

  disconnect() {
    if (!this._bound) return
    this.element.removeEventListener("input", this._bound)
    this.element.removeEventListener("change", this._bound)
  }

  _update() {
    if (!this.hasClearTarget) return
    this.clearTarget.classList.toggle("hidden", !this._hasActiveFilter())
  }

  _hasActiveFilter() {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]:checked')
    if (checkboxes.length > 0) return true

    const valueInputs = this.element.querySelectorAll(
      'input[name="bank_account_id"], input[name="cost_center_id"], input[name="date_range"], input[name="search"], input[name="start_date"], input[name="end_date"]'
    )
    for (const input of valueInputs) {
      if ((input.value || "").trim() !== "") return true
    }
    return false
  }
}
